import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 0 -12px;
  max-height: 200px;
  overflow-y: auto;
`;

export const Block = styled.div`
  margin: 0 0 12px;
  width: 100%;
  text-align: center;
  button {
    width: 100%;
  }
`;
